import { system } from 'styled-system';

export const rowGap = system({
  rowGap: {
    property: 'rowGap',
    scale: 'space',
    transform: (value, scale) => {
      if (value) {
        let propertyValue = value;
        if (typeof value === 'string') propertyValue = scale[parseInt(value)];
        return propertyValue;
      }

      return 0;
    },
  },
});
